import { ParcoursStubPage } from '../../../components/parcours/ParcoursStubPage';
import { getParcoursStub } from '../../../config/parcours-particuliers';

export default function BilanEnergetiquePage() {
  const parcours = getParcoursStub('bilan-energetique');
  if (!parcours) return null;
  return <ParcoursStubPage parcours={parcours} />;
}
